import * as React from 'react';
import * as styles from './Divider.css';

export interface IDividerProps {
  weight?: number;
  color?: string;
  length?: number;
  style?: React.CSSProperties;
  onClick?: () => void;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
}


export class IADivider extends React.Component<IDividerProps> {

  constructor(props: IDividerProps) {
    super(props);
  }

  public render(): JSX.Element {

    const weight = this.props?.weight;
    const color = this.props?.color;
    const length = this.props?.length;

    return (
      <div className={styles.IA_Divider}

        onClick={() => this.props.onClick && this.props.onClick()}

        onMouseOver={() => this.props.onMouseOver && this.props.onMouseOver()}

        onMouseLeave={() => this.props.onMouseLeave && this.props.onMouseLeave()}

      >
        <hr className={styles.IA_DividerHR}
          style={{
            width: `${length}%`,
            borderTop: `${weight}px solid ${color}`,
            ...this.props.style
          }}
        />
      </div>

    );
  }
}